const PROD = 'prod';
const DEV = 'dev';

let env;
if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_HOST) {
  const host = process.env.REACT_APP_HOST;
  [, env] = host.split('://');
} else {
  env = window.location.hostname;
}

if (env.startsWith('wappsto')) {
  env = PROD;
} else if (env.startsWith('localhost')) {
  env = DEV;
} else {
  [env] = env.split('.');
}

const configFilenames = {
  firebase: 'firebaseConfig',
  recaptcha: 'recaptchaConfig',
  stripe: 'stripeConfig',
};

const configCache = new Map();

/**
 * @returns {Promise<any>}
 */
export default async function getConfigFile(file) {
  if (configCache.has(file)) return configCache.get(file);

  try {
    const filename = configFilenames[file] || file;
    const response = await fetch(`/config_files/${filename}.json`);
    const contentType = response.headers.get('content-type');
    if (response.ok && contentType && contentType.includes('application/json')) {
      const json = await response.json();
      configCache.set(filename, json);
      return json;
    }
  } catch (e) {
    // Ignore fetch error and fallback to local require
  }

  try {
    /* eslint-disable-next-line import/no-dynamic-require, global-require */
    const mod = await import(`./${env}/${file}.json`);
    const json = mod.default || mod;
    configCache.set(file, json);
    return json;
  } catch (e) {
    return {};
  }
}
